import produce from 'immer';
import { isEmpty } from 'lodash';

import type { GamesByClubs } from '@swf/core/types/Poker';
import type { ScheduledTourn } from '@swf/generated/types/api/v0/SwHomeGames';

export interface Props {
  tournaments: GamesByClubs;
  scheduled: ScheduledTourn[];
}

// Remove tournaments from game tiles which have already been registered.
const filterRegisteredTournaments = ({ tournaments, scheduled }: Props) =>
  produce(tournaments, (draft) => {
    const noGames = isEmpty(tournaments);
    const noScheduled = isEmpty(scheduled);

    if (noScheduled && !noGames) return tournaments;
    if (noScheduled && noGames) return {};

    scheduled.forEach(({ clubId, tournId }) => {
      const index = draft[Number(clubId)]?.findIndex(
        (tourn) => Number(tourn.id) === Number(tournId)
      );

      if (index > -1) {
        draft[Number(clubId)] = draft[Number(clubId)].filter((_, i) => i !== index);
      }
    });
  });

export default filterRegisteredTournaments;
